import { render } from "./TalentService.vue?vue&type=template&id=185ee088&scoped=true"
import script from "./TalentService.vue?vue&type=script&lang=js"
export * from "./TalentService.vue?vue&type=script&lang=js"

import "./TalentService.vue?vue&type=style&index=0&id=185ee088&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185ee088"]])

export default __exports__